import * as React from 'react';
import { useEffect } from 'react';

import { InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/academic-integrity';

const TRANSIENT_DURATION = 8000; // ms

type Props = {
  onDismiss: () => void;
};

const PasteDeterrenceNotification: React.FC<Props> = ({ onDismiss }) => {
  useEffect(() => {
    setTimeout(() => onDismiss(), TRANSIENT_DURATION);
  });
  return (
    <InlineNotification severity="warning" onDismiss={onDismiss}>
      {_t('Looks like you’ve pasted your answer. Ensure it’s your original work before submitting.')}
    </InlineNotification>
  );
};

export default PasteDeterrenceNotification;
